'use client'

import { Accordion } from '@fukku/accordion'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import type { Store } from 'maps/types'
import { sendSearchStoreHoursEvent } from 'maps/utils/analytics/events'

import { Disclaimer } from './Disclaimer/Disclaimer'
import { Phone } from './Phone/Phone'
import { Schedule } from './Schedule/Schedule'

interface StoreScheduleProps {
	readonly store: Store
	readonly showPhone?: boolean
	readonly showDisclaimer?: boolean
}

export function StoreSchedule({
	store,
	showPhone = false,
	showDisclaimer = false,
}: StoreScheduleProps): React.ReactNode {
	const { t } = useLabels()

	const onExpanded = () => {
		sendSearchStoreHoursEvent()
	}

	return (
		<Accordion
			hasBorderBottom={false}
			secondary
			id={`${store.id}-accordion`}
			data={[
				{
					title: t('storeLocator.card.schedule.link'),
					content: store.details ? (
						<>
							<Schedule id={store.id} schedule={store.details.timeSchedule} />
							{showPhone && <Phone store={store} />}
							{showDisclaimer && (
								<Disclaimer isCorner={store.details.isCorner ?? false} />
							)}
						</>
					) : null,
					shouldScroll: false,
					dataTestId: `maps.address.store.${store.id}.schedule`,
					onExpanded,
				},
			]}
		/>
	)
}
